import React from "react";
import withIconComponent from "../withIconComponent";

var ChevronUp = function ChevronUp() {
  return /*#__PURE__*/React.createElement("path", {
    d: "M8 14l4-4 4 4",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  });
};

export default withIconComponent("UiChevronUp", false)(ChevronUp);